const BUILTIN_ADMIN_ROLE_NAMES: Record<string, string> = {
  wjs_admin_super: '万剪师超级管理员',
  wjs_admin_security: '安全管理员',
  wjs_admin_ops: '运维管理员',
  wjs_admin_ai_resource: 'AI 资源管理员',
  wjs_admin_finance: '财务管理员',
  wjs_admin_content: '内容运营',
  wjs_admin_customer_service: '客户服务',
  wjs_admin_auditor: '审计员',
};

export function formatAdminRoleName(role: string): string {
  const value = String(role || '').trim();
  return BUILTIN_ADMIN_ROLE_NAMES[value] ?? value;
}

export function formatAdminRoleNames(roles?: string[] | null): string[] {
  return (roles ?? []).map(formatAdminRoleName).filter(Boolean);
}
